export default {
  name: "Bedrijven",
  single: "Bedrijf",

  api: {
    company: {
      name: {
        notNull: "Voer een bedrijfsnaam in.",
      },
    },
  },
}
